<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->

    <div class="right-menu">
      <!-- <template v-if="device!=='mobile'">
        <search id="header-search" class="right-menu-item" />

        <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>

      </template>
      -->
      
    
      <div class="avatar-container right-menu-item hover-effect" trigger="click">
       <div class="header-title">
          欢迎登录<span style="color:#1890ff">阿米巴能量</span>, {{datas.username}}
        <span @click="logoutHandle()" style="margin-left:20px" class="out">退出</span>
        <span style="margin-left:20px" @click="updatePasswordHandle()" class="change">修改密码</span>
        </div>
      </div>
    </div>
     <!-- 弹窗, 修改密码 -->
    <update-password v-if="updatePassowrdVisible" :username='datas.username' @isModelHeidden='isHeidden' :isShow='isShow' ref="updatePassowrd"></update-password>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import { removeToken } from '@/utils/auth'
import UpdatePassword  from './main-navbar-update-password.vue'
import Bus from '@/utils/bus'
import {getInfo} from '@/api/user'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search,
    UpdatePassword
  },
  data() {
    return {
      updatePassowrdVisible: false,
      datas:{},
      isShow:false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'name'
    ])
  },
  mounted() {
    getInfo().then(res =>{
      // console.log(res)
      this.datas = res.user;
      sessionStorage.setItem("companyCode",res.user.companyCode);
      sessionStorage.setItem("isChairman",res.user.isChairman);
      sessionStorage.setItem("isLeader",res.user.isLeader);
      sessionStorage.setItem('teamId',res.user.teamId)
    })
  },
  methods: {
    //点击修改密码
     // 修改密码
      updatePasswordHandle () {
        
        let that = this
        this.updatePassowrdVisible = true
        this.$nextTick(() => {
          this.isShow = true
          // console.log( that.$refs.updatePassowrd)
          // Bus.$emit('init',true)
        })
      },
      // 监听关闭弹窗
      isHeidden(e) {
        this.isShow = false
      },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    
    logoutHandle () {
      this.$confirm(`确定进行[退出]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeToken()
        location.reload();
      }).catch(() => {})
    }
  
  }
}
</script>

<style lang="scss" scoped>
.header-title{
  font-size: 16px;
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
